export default __webpack_public_path__ + "static/media/img-timesup.94b7369f.svg";